import { render, staticRenderFns } from "./designerNew.vue?vue&type=template&id=a4332736&scoped=true"
import script from "./designerNew.vue?vue&type=script&lang=js"
export * from "./designerNew.vue?vue&type=script&lang=js"
import style0 from "./designerNew.vue?vue&type=style&index=0&id=a4332736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4332736",
  null
  
)

export default component.exports